(function () {
  var list = document.querySelectorAll('.rnc-video-facade');
  for (var k = 0; k < list.length; k++) {
    bindFacade(list[k]);
  }

  function bindFacade(f) {
    f.addEventListener(
      'click',
      function () {
        var container = f.closest('.rnc-cp-video');
        if (!container) return;
        var src = f.getAttribute('data-rnc-video');
        var v = document.createElement('video');
        v.setAttribute('controls', '');
        v.setAttribute('autoplay', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'auto');
        var s = document.createElement('source');
        s.src = src;
        s.type = 'video/mp4';
        v.appendChild(s);
        container.querySelectorAll('.rnc-video-facade').forEach(function (el) {
          el.remove();
        });
        container.appendChild(v);
        if (v.play) {
          var p = v.play();
          if (p && p.catch) {
            p.catch(function () {});
          }
        }
      },
      { once: true }
    );
  }
})();
